import { Fieldset, TextField, SubTitle } from '@repo/ui';
import { ChangeEvent, useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useBznavRefundUserPhone } from '@/lib/hooks/api/query/use-bznav-refund-user-phone';

const PhoneNumberForm = () => {
  const phone = useBznavRefundUserPhone();

  const {
    formState: { errors },
    trigger,
    register,
    setValue,
    reset
  } = useFormContext();

  const resetForm = useCallback(() => {
    if (!phone) return;

    reset({
      phone: phone
        .trim()
        .replace(/[^0-9]/g, '')
        .replace(/^(\d{3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
    });
    trigger('phone');
  }, [phone, reset, trigger]);

  useEffect(() => {
    resetForm();
  }, [resetForm]);
  const handleChangePhone = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value }
    } = e;
    const newValue = value
      .trim()
      .replace(/[^0-9]/g, '')
      .replace(/^(\d{3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);

    setValue('phone', newValue);
  };

  return (
    <>
      <SubTitle title={<span className={'font-bold'}>휴대폰번호</span>} description={`환급 진행 안내를 위해 휴대폰번호를 입력해주세요.`} size={'large'} />
      <Fieldset isInvalid={!!errors.phone} errorMessage={'올바른 휴대폰 번호를 입력해주세요.'} className={'w-full !pb-normal-large'}>
        <TextField
          maxLength={20}
          pattern="\d*"
          inputMode="numeric"
          type="text"
          className="w-full"
          placeholder="- 없이 숫자만 입력"
          {...register('phone', {
            required: true,
            onChange: handleChangePhone,
            onBlur: () => trigger('phone')
          })}
          error={!!errors.phone}
        />
      </Fieldset>
    </>
  );
};

export default PhoneNumberForm;
